/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RasterDto } from '../../models/raster-dto';

export interface MergeRaster$Params {
  id: string;
}

export function mergeRaster(http: HttpClient, rootUrl: string, params: MergeRaster$Params, context?: HttpContext): Observable<StrictHttpResponse<RasterDto>> {
  const rb = new RequestBuilder(rootUrl, mergeRaster.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RasterDto>;
    })
  );
}

mergeRaster.PATH = '/v1/raster/merge/{id}';
